module.exports = __webpack_public_path__ + "img/is.6ddeb968.svg";